import type { Template } from "@/types";

export const PO_02_H1_V1: Template[] = [
    {
        id: "po-02-h1v1-01",
        name: "PO 01 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 64, y: 272, width: 559, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 860, y: 202, width: 342, height: 513, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-02-h1v1-02",
        name: "PO 02 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 64, y: 272, width: 559, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 806, y: 121, width: 449, height: 674, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-02-h1v1-03",
        name: "PO 03 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 64, y: 272, width: 559, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 687, y: 0, width: 687, height: 916, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-04",
        name: "PO 04 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_04.png",
        size: [1374, 916],
        style: {},     
        slots: [
            { id: "1", x: 0, y: 230, width: 687, height: 457, rotation: 0, imageRotation: 0 },
            { id: "2", x: 727, y: 0, width: 608, height: 916, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-05",
        name: "PO 05 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 58, y: 146, width: 853, height: 618, rotation: 0, imageRotation: 0 },
            { id: "2", x: 919, y: 146, width: 397, height: 618, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-02-h1v1-06",
        name: "PO 06 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 127, width: 940, height: 662, rotation: 0, imageRotation: 0 },
            { id: "2", x: 948, y: 128, width: 425, height: 661, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-07",
        name: "PO 07 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_07.png",
        size: [1374, 916],
        style: {},
        slots: [        
            { id: "1", x: 119, y: 121, width: 449, height: 674, rotation: 0, imageRotation: 0 },
            { id: "2", x: 751, y: 272, width: 559, height: 373, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-08",
        name: "PO 08 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 687, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 751, y: 272, width: 559, height: 373, rotation: 0, imageRotation: 0 }        
        ],
    },
    {
        id: "po-02-h1v1-09",
        name: "PO 09 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 39, y: 0, width: 608, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 687, y: 230, width: 687, height: 457, rotation: 0, imageRotation: 0 }          
        ],
    },

    {
        id: "po-02-h1v1-10",
        name: "PO 10- H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 172, y: 202, width: 342, height: 513, rotation: 0, imageRotation: 0 },
            { id: "2", x: 751, y: 272, width: 559, height: 373, rotation: 0, imageRotation: 0 }       
        ],
    },


];




